module.exports = "/_next/static/images/trade-2815de8d0bf81d70e8bd24dbf1a9ed1e.svg";